export default "__VITE_ASSET__CMoQeats__"